
import React from 'react';
import ConditionPageTemplate from './ConditionPageTemplate';

const UnevenToneTexture = () => {
  const treatments = [
    {
      name: "RF Microneedling",
      href: "/treatments/rf-microneedling",
      description: "Stimulate collagen production for smoother texture",
      price: "$649",
      memberPrice: "$499"
    },
    {
      name: "Laser Facial",
      href: "/treatments/laser-facial",
      description: "Target pigmentation and improve skin tone",
      price: "$450",
      memberPrice: "$349"
    },
    {
      name: "VI Peel",
      href: "/treatments/vi-peel",
      description: "Chemical exfoliation for brighter, even skin",
      price: "$299",
      memberPrice: "$229"
    },
    {
      name: "Ultrasound Facial",
      href: "/treatments/ultrasound-facial",
      description: "Gentle resurfacing for sensitive skin",
      price: "$350",
      memberPrice: "$269"
    }
  ];

  return (
    <ConditionPageTemplate
      title="Uneven Tone & Texture"
      subtitle="Smooth, Bright, Balanced"
      description="Uneven texture, sun damage, and roughness are addressed with exfoliating, resurfacing, and collagen-inducing treatments. Perfect for rough texture, large pores, sun damage, and uneven skin tone."
      treatments={treatments}
      beforeAfterText="Results build over 3 visits — members get discounted maintenance packages."
    />
  );
};

export default UnevenToneTexture;
